export default __webpack_public_path__ + "static/media/Isla 9781408312926.0e919ab7.jpg";